// extracted by mini-css-extract-plugin
module.exports = {"notFound":"appointments__NoResultsCard__notFound","notFoundText":"appointments__NoResultsCard__notFoundText"};